// extracted by mini-css-extract-plugin
export var avatarContainer = "_a5-0";
export var avatarTypingWave = "_a5-i";
export var gray = "_a5-f";
export var green = "_a5-c";
export var icon = "_a5-9";
export var image = "_a5-1";
export var lg = "_a5-6";
export var md = "_a5-5";
export var presenceDot = "_a5-b";
export var red = "_a5-d";
export var sm = "_a5-4";
export var status = "_a5-a";
export var typingDot = "_a5-h";
export var typingPill = "_a5-g";
export var xl = "_a5-7";
export var xs = "_a5-3";
export var xxl = "_a5-8";
export var xxs = "_a5-2";
export var yellow = "_a5-e";